<template>
  <div>
    <el-input class="select-input" readonly v-model="value" :disabled="disabled">
      <el-button slot="append" class="select-btn" :disabled="disabled" @click="dialogOpen = true">选择</el-button>
    </el-input>

    <el-dialog destroy-on-close top="5vh" :visible.sync="dialogOpen" @opened="hendleOpened">
      <template slot="title">
        <div class="dialog-title">{{ title }}</div>
      </template>

      <el-form :inline="true" :model="form">
        <el-form-item v-for="(item, index) in queryItems" :key="index" :label="item.label">
          <el-input v-model="form[item.prop]" :placeholder="item.placeholder"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch">
            <i class="el-icon el-icon-search" />查询
          </el-button>
          <el-button size="small" @click="resetForm">
            <i class="el-icon el-icon-refresh-right" />重置
          </el-button>
        </el-form-item>
      </el-form>
      <Table ref="table" :loading="loading" :props="innerTable.props" :header="innerTable.header" :data="innerTable.data" />
      <pagination
        backgroud
        :currentpage="pager.currentPage"
        :pagesize="pager.pageSize"
        :totalcount="pager.total"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '选择' },
    table: { type: Object, default: () => {} },
    value: { type: String, default: '' }
  },
  data() {
    return {
      dialogOpen: false,
      form: {},
      loading: false,
      innerTable: {
        props: this.table.props,
        header: [
          ...this.table.header,
          {
            label: '操作',
            align: 'left',
            width: 100,
            fixed: 'right',
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleSelect(row)
                      }
                    }
                  },
                  '选择'
                )
              ])
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    queryItems() {
      return this.table.header.filter(item => item.query === true)
    }
  },
  methods: {
    hendleOpened() {
      this.handleSearch()
    },
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pager.pageSize, this.pager.currentPage]
      const filter = { pageSize, pageNo, ...this.form }
      this.table
        .api(filter)
        .then(data => {
          this.loading = false
          this.innerTable.data = data.rows || []
          this.pager.total = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSearch() {
      this.pager.currentPage = 1
      this.pager.pageSize = 10
      this.fetchData()
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    resetForm() {
      this.queryItems.forEach(item => {
        if (item.prop in this.form) {
          this.form[item.prop] = undefined
        }
      })
    },
    handleSelect(rowData) {
      this.$emit('data-select', rowData)
      this.dialogOpen = false
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .el-dialog__body
  padding 0 40px 20px 30px
.el-input >>> .el-input-group__append
  background-color #fff
  &:hover, &:focus
    color #FF8B00
    border-color #ffdcb3
    background-color #fff3e6
.el-form
  margin 15px 0
.dialog-title
  border-bottom 1px solid #eee
.select-input
  width 400px
.select-btn
  cursor pointer
</style>
